/** Atomik satışın çökme kurtarması için yazıldığı ESKİ tek yuvalı anahtar (yalnızca okunur). */
export const PENDING_ATOMIC_PAYMENT_KEY = 'gts_pending_atomic_payment';

/**
 * Çok yuvalı kuyruk (IdempotencyKey → kayıt). Bkz. pendingAtomicPayments.ts.
 * Oturum kapatılınca SİLİNMEZ: kaydedilemeyen satış kaybolmasın.
 */
export const PENDING_ATOMIC_PAYMENTS_STORE_KEY = 'gts_atomic_payments_pending_v2';

export type AccessLockCode = 'DEMO_EXPIRED' | 'ACCESS_EXPIRED';

function responseData(error: unknown): Record<string, unknown> | null {
  const data = (error as { response?: { data?: unknown } } | null)?.response?.data;
  return data && typeof data === 'object' ? (data as Record<string, unknown>) : null;
}

/** 403 + DEMO_EXPIRED / ACCESS_EXPIRED ise kodu döner. */
export function accessLockCode(error: unknown): AccessLockCode | null {
  const status = (error as { response?: { status?: number } } | null)?.response?.status;
  if (status !== 403) return null;
  const data = responseData(error);
  const code = data?.code ?? data?.Code;
  if (code === 'DEMO_EXPIRED' || code === 'ACCESS_EXPIRED') return code;
  return null;
}

/** Süre/erişim kilidinde bekleyen tüm kayıtları temizler (hiçbiri kaydedilemez). */
export function clearPendingAtomicPayment(): void {
  try {
    localStorage.removeItem(PENDING_ATOMIC_PAYMENT_KEY);
    localStorage.removeItem(PENDING_ATOMIC_PAYMENTS_STORE_KEY);
  } catch {
    /* depolama kapalıysa kuyruk zaten yazılamamıştır */
  }
}

export function accessLockMessage(error: unknown): string {
  const data = responseData(error);
  const message = data?.message ?? data?.Message;
  if (typeof message === 'string' && message.trim()) return message.trim();
  return 'Süreniz dolmuştur. Satış kaydedilemedi. Lütfen bizimle iletişime geçin.';
}
